<template>
    <div class="col-sm-12 form-group">
        <label>{{ label }}</label>
        <div class="input-group">
            <textarea
                    :id="textareaId"
                    rows="7"
                    class="form-control"
                    readonly
                    v-text="textareaValue"
            ></textarea>
            <span class="input-group-addon">
                <a :data-clipboard-target="'#'+textareaId" class="btn-clipboard">
                    <i class="fa fa-clipboard"></i>
                </a>
            </span>
        </div>
        <div class="text-right small p-xxs" v-if="textareaValue">
            <span>{{ textareaValue.length }}</span>
        </div>
        <div
                class="small"
                v-if="translation"
        >
            <strong>Former text:</strong>
            <span v-text="getTranslation('translation_data_decoded.text.last_translation_base')"></span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        label: String,
        textField: Object,
        variant: Object,
        selectedLanguage: Object,
    },
    methods: {
        getTranslation(fieldName) {
            return _.get(this.translation, fieldName);
        },
    },
    computed: {
        textareaValue() {
            if (this.variant) {
                return _.find(this.variant.texts, {'type': this.textField.value.type}).text;
            }

            return this.textField.value.text;
        },
        textareaId() {
            if (this.variant) {
                return `translation-textarea-original-${this.textField.value.id}-${this.variant.id}`;
            }

            return `translation-textarea-original-${this.textField.value.id}`;
        },
        translation() {
            return _.find(this.textField.value.translation_items, {'language_id': this.selectedLanguage.id});
        }
    }
}
</script>
